module.exports = __webpack_public_path__ + "img/DAVID_CANNON_15-rs.c6f9381b.jpg";